import { Anchor } from "client/Components";
import { useCallbackWithoutArguments } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { HubListButton } from "../KnowledgeItems/CategoryOverview/List/HubItem/HubListButton";
import { HubDataSource } from "client/Api/Hub/hub";

export type ViewAllProps = {
	itemSource: HubDataSource;
	onClick: () => void;
	variant: "list-item" | "anchor";
	isMobileVariant?: boolean;
};

export const ViewAll = (props: ViewAllProps): ReactElement => {
	const {
		itemSource,
		onClick: onClickFromProps,
		variant
	} = props;

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);

	const {
		key,
		trackingId
	} = kindToOptionsMap[itemSource];

	const Component: typeof HubListButton | typeof Anchor = variant === "list-item"
		? HubListButton
		: Anchor;

	return (
		<Component
			trackingId={trackingId}
			onClick={onClick}
		>
			{localize(key)}
		</Component>
	);
};
ViewAll.displayName = "ViewAll";

const kindToOptionsMap: Record<HubDataSource, { key: LocalizationKey; trackingId: string; }> = {
	[HubDataSource.Announcement]: {
		key: "_ViewAllAnnouncements",
		trackingId: "view-all-announcements"
	},
	[HubDataSource.KnowledgeItem]: {
		key: "_ViewAllKnowledgeArticles",
		trackingId: "view-all-knowledge-items"
	},
	[HubDataSource.Event]: {
		key: "_ViewAllEvents",
		trackingId: "view-all-events"
	},
	[HubDataSource.Community]: {
		key: "_ViewMyFeed",
		trackingId: "view-my-feed"
	}
};